import { writable } from "svelte/store";
type WidgetState = {
	isWizardOpen: boolean;
};
export const widgetState = writable<WidgetState>({
	isWizardOpen: false
});
